module.exports = __webpack_public_path__ + "static/media/Port_Paraya.8bc48b06.md";